import { useTranslation } from "../../../hooks";

const Row = ({ title, content }: { title: string; content?: string }) => {
  if (!content) {
    return <></>;
  }

  return (
    <div style={{ display: "flex", marginBottom: "8px" }}>
      <span style={{ flex: 2 }}>{title}</span>
      <span style={{ flex: 1 }}>{content || ""}</span>
    </div>
  );
};

const ResubmitPrompterContent = (props: Record<string, string>) => {
  const { t } = useTranslation("swapRequestRecord");

  return (
    <>
      {Object.entries(props).map(([key, value]) => (
        <Row key={`resubmit-${key}`} title={t(key)} content={value} />
      ))}
    </>
  );
};

export default ResubmitPrompterContent;
